import { render } from "./shortlist-candidates.vue?vue&type=template&id=5ecd6a74"
import script from "./shortlist-candidates.vue?vue&type=script&lang=js"
export * from "./shortlist-candidates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__